import { mapGetters } from 'vuex'
import suggestion from '@/store/modules/suggestion'

export const blobSuggestionLoader = {
    created () {
        // register admin store module
        this.$store.registerModule('suggestion', suggestion)
        this.$store.dispatch('suggestion/loadBlobs')
        this.loadBlobs()
    },
    beforeDestroy () {
        // unregister admin store module
        this.$store.unregisterModule('suggestion')
    },

    computed: {
        ...mapGetters({
            initialised: 'suggestion/blobsInitialised',
            blobs: 'suggestion/blobs'
        }),
        isLoading: function () {
            return (this.blobs === undefined)
        }
    },

    methods: {
        loadBlobs() {
            if(!this.initialised)
            {
                this.$store.dispatch('suggestion/loadBlobs');
            }
        }
    }
}
